var _g, _g2, _g3, _rect, _rect2, _g4, _animateTransform, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 81,
    viewBox: "0 0 84 81",
    style: {
      backgroundColor: "#FFFFFF",
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Frame 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    x: 19,
    y: 17,
    width: 0.01,
    height: 0.01,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "anchorPointContainer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    label: "flipped",
    transform: "scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerRotation",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "Group 256Container",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "",
    label: "maskPath"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerShadow",
    filter: ""
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 0.01,
    height: 0.01,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "anchorPointContainer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    label: "flipped",
    transform: "scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerRotation",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "Ellipse 2Container",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "",
    label: "maskPath"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerShadow",
    filter: "url(#ellipse_2-shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,50c13.75,0,25,-11.25,25,-25 0,-13.75,-11.25,-25,-25,-25 -13.75,0,-25,11.25,-25,25 0,13.75,11.25,25,25,25zM25,50",
    fill: "#FFFFFF",
    id: "ellipse_2",
    stroke: "#00000000",
    strokeDasharray: 0,
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeWidth: 1
  })))))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 5,
    y: 16,
    width: 0.01,
    height: 0.01,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "anchorPointContainer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    label: "flipped",
    transform: "scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerRotation",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 19.98,
    height: 26.22,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "Group 255Container",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "",
    label: "maskPath"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerShadow",
    filter: ""
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: 13,
    y: 10,
    width: 0.01,
    height: 0.01,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "anchorPointContainer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    label: "flipped",
    transform: "scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerRotation",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 6.98,
    height: 16.22,
    style: {
      overflow: "visible"
    },
    opacity: 0,
    label: "Vector 1 (Stroke)Container",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "",
    label: "maskPath"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerShadow",
    filter: "url(#vector_1_stroke_-shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.663,0.035c0.257,0.101,0.384,0.391,0.283,0.648 0,0,-5.98,15.22,-5.98,15.22 -0.101,0.257,-0.391,0.384,-0.648,0.283 -0.257,-0.101,-0.384,-0.391,-0.283,-0.648 0,0,5.98,-15.22,5.98,-15.22 0.101,-0.257,0.391,-0.384,0.648,-0.283 0,0,0,0,0,0zM6.663,0.035",
    fill: "#F02942",
    id: "vector_1_stroke_",
    stroke: "#00000000",
    strokeDasharray: 0,
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 4,
    strokeWidth: 1
  })))))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 18.86,
    y: 0,
    width: 0.01,
    height: 0.01,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "anchorPointContainer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    label: "flipped",
    transform: "scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerRotation",
    transform: "rotate(85.56)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 8.93,
    height: 18.92,
    style: {
      overflow: "visible"
    },
    opacity: 0,
    label: "Vector 2 (Stroke)Container",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "",
    label: "maskPath"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerShadow",
    filter: "url(#vector_2_stroke_-shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.632,0.043c0.252,0.112,0.366,0.407,0.255,0.66 0,0,-7.93,17.92,-7.93,17.92 -0.112,0.253,-0.407,0.367,-0.659,0.255 -0.252,-0.112,-0.366,-0.407,-0.255,-0.66 0,0,7.93,-17.92,7.93,-17.92 0.112,-0.253,0.407,-0.367,0.659,-0.255 0,0,0,0,0,0zM8.632,0.043",
    fill: "#414141",
    id: "vector_2_stroke_",
    stroke: "#00000000",
    strokeDasharray: 0,
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 4,
    strokeWidth: 1
  })))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: "100%",
    rx: 0,
    stroke: "#00000000",
    strokeWidth: 1,
    width: "100%",
    x: 0,
    y: 0
  })))))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: "100%",
    rx: 0,
    stroke: "#00000000",
    strokeWidth: 1,
    width: "100%",
    x: 0,
    y: 0
  })))))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 43.5,
    y: 42.75,
    width: 0.01,
    height: 0.01,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "anchorPointContainer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    label: "flipped",
    transform: "scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerRotation",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: -15.5,
    width: 1,
    height: 15.5,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "Vector 4 (Stroke)Container",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "",
    label: "maskPath"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerShadow",
    filter: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0c0.276,0,0.5,0.224,0.5,0.5 0,0,0,14.5,0,14.5 0,0.276,-0.224,0.5,-0.5,0.5 -0.276,0,-0.5,-0.224,-0.5,-0.5 0,0,0,-14.5,0,-14.5 0,-0.276,0.224,-0.5,0.5,-0.5 0,0,0,0,0,0zM0.5,0",
    fill: "#F02942",
    id: "vector_4_stroke_",
    stroke: "#00000000",
    strokeDasharray: 0,
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1
  })))))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 44.5,
    y: 41.5,
    width: 0.01,
    height: 0.01,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "anchorPointContainer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    label: "flipped",
    transform: "scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerRotation",
    transform: "rotate(0)"
  }, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    dur: 4,
    fill: "freeze",
    keySplines: "0.42 0 0.58 1;0.42 0 0.58 1",
    keyTimes: "0;0.3;1",
    label: "Vector 5 (Stroke)",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0;360;360"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: -14,
    y: 0,
    width: 14,
    height: 18,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "Vector 5 (Stroke)Container",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "",
    label: "maskPath"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerShadow",
    filter: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.804,0.103c0.219,0.168,0.261,0.482,0.093,0.701 0,0,-13,17,-13,17 -0.168,0.219,-0.482,0.261,-0.701,0.093 -0.219,-0.168,-0.261,-0.481,-0.093,-0.701 0,0,13,-17,13,-17 0.168,-0.219,0.482,-0.261,0.701,-0.093 0,0,0,0,0,0zM13.804,0.103",
    fill: "#414141",
    id: "vector_5_stroke_",
    stroke: "#00000000",
    strokeDasharray: 0,
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1
  })))))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 42.48,
    y: 40.48,
    width: 0.01,
    height: 0.01,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "anchorPointContainer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    label: "flipped",
    transform: "scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerRotation",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 3.03,
    height: 3.03,
    style: {
      overflow: "visible"
    },
    opacity: 1,
    label: "Ellipse 3Container",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "",
    label: "maskPath"
  }, /*#__PURE__*/React.createElement("g", {
    label: "layerShadow",
    filter: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.515,3.03c0.833,0,1.515,-0.682,1.515,-1.515 0,-0.833,-0.682,-1.515,-1.515,-1.515 -0.833,0,-1.515,0.682,-1.515,1.515 0,0.833,0.682,1.515,1.515,1.515zM1.515,3.03",
    fill: "#F02942",
    id: "ellipse_3",
    stroke: "#00000000",
    strokeDasharray: 0,
    strokeDashoffset: 0,
    strokeMiterlimit: 4,
    strokeWidth: 1
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ellipse_2-shadow",
    x: "-50%",
    y: "-50%",
    height: "200%",
    width: "200%",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    id: "ellipse_2-shadow-filter",
    dx: 5,
    dy: 4,
    floodColor: "#0000001D",
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vector_1_stroke_-shadow",
    x: "-50%",
    y: "-50%",
    height: "200%",
    width: "200%",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    id: "vector_1_stroke_-shadow-filter",
    dx: 0,
    dy: 2,
    floodColor: "#00000033",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vector_2_stroke_-shadow",
    x: "-50%",
    y: "-50%",
    height: "200%",
    width: "200%",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    id: "vector_2_stroke_-shadow-filter",
    dx: 0,
    dy: 2,
    floodColor: "#00000033",
    stdDeviation: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockAnimated);
export default __webpack_public_path__ + "static/media/clockAnimated.2dd8b16c87e33468e3fa16d341b40888.svg";
export { ForwardRef as ReactComponent };